import './goto.sss';
const $ = window.$ || window.jQuery;


export default class GoTo {


    constructor() {
        this.list = $('.list_items_goto');
       
        if (this.list.length) {
            this.collLeft = $('.colls_list_and_goto .coll.left');
            this.headerHeight = $('.block.block-menu.navigation').outerHeight();
            this.offsetTop = this.collLeft.offset().top;

            this.items = $('.list_items_goto .field__item');
            this.headers = $('h1, h2, h3, h4, h4');

            this.controllers();
        }
    }

    controllers() {

        this.items.on('click', e => {
            const current = $(e.currentTarget);
            const text = current.text();
            this.headers.each( (i, el) => {
                if (text === $(el).text()) {
                    $('html, body').animate({
                        scrollTop: $(el).offset().top - this.headerHeight
                    }, 500, function () {
                       
                    })
                }
            });
        });

        $(window).on('scroll', e => {
            const top = window.scrollY || $('html, body').scrollTop();
            const region = this.offsetTop - this.headerHeight;
            if (top > region) {

                this.collLeft.css({
                    top: top - region
                });
            } else {
                this.collLeft.css({
                    top: 0
                });
            }
            
        });
    }

}


// WEBPACK FOOTER //
// ./modules/GoTo/index.js